import React, { useState } from 'react';

const RegimenInfoDisplayStep = ({ question, value, onAnswer, onNext, answers }) => {
  const [selectedRegimen, setSelectedRegimen] = useState(value || '');

  // Determine medication type from previous answers
  const getMedicationType = () => {
    const recentDose = answers?.['recent-dose'] || answers?.['current-dose'];
    
    if (recentDose) {
      const doseLower = recentDose.toLowerCase();
      if (doseLower.includes('tirzepatide')) return 'tirzepatide';
      if (doseLower.includes('semaglutide') || doseLower.includes('ozempic') || doseLower.includes('wegovy')) return 'semaglutide';
    }
    
    const currentMedication = answers?.['current-glp-medications'];
    if (Array.isArray(currentMedication)) {
      if (currentMedication.includes('tirzepatide')) return 'tirzepatide';
      if (currentMedication.includes('semaglutide')) return 'semaglutide';
    }
    
    return 'semaglutide';
  };

  const medicationType = getMedicationType();
  const options = medicationType === 'tirzepatide' 
    ? question.tirzepatideOptions 
    : question.semaglutideOptions;

  const handleSelect = (e) => {
    const val = e.target.value;
    setSelectedRegimen(val);
    onAnswer(val);
  };

  return (
    <div data-testid={`step-${question.id}`}>
      <h2 className="text-2xl md:text-3xl font-semibold text-center text-gray-900 mb-4">
        {question.question}
      </h2>

      <div className="bg-gray-50 rounded-lg p-5 mb-6 border border-gray-200">
        <h3 className="text-lg font-semibold text-gray-800 mb-2">
          {medicationType === 'tirzepatide' ? 'Tirzepatide' : 'Semaglutide'}: {question.regimenTitle}
        </h3>
        <p className="text-sm text-gray-600 mb-4">
          {question.regimenSubtitle}
        </p>

        <label className="block text-sm font-medium text-gray-700 mb-2">
          Possible regimen the doctor may prescribe:
        </label>
        <select
          value={selectedRegimen}
          onChange={handleSelect}
          className="form-input w-full"
          data-testid="regimen-select"
        >
          <option value="">-- Select a regimen option --</option>
          {options.map((option, index) => (
            <option key={index} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>

      <button
        onClick={onNext}
        disabled={!selectedRegimen}
        className="btn-primary"
        data-testid="continue-button"
      >
        Continue
      </button>
    </div>
  );
};

export default RegimenInfoDisplayStep;
